import  { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HideSpinner, ShowSpinner } from "../redux/actions/SpinnerAction";
import { ErrorToast, SuccessToast } from "../redux/actions/ToasterAction";
import * as WaitlistActions from "../redux/actions/WaitlistAction"
import _ from "lodash";

const useWaitlist = ({refresh= true})=>{
     
    const allWaitlist = useSelector((state)=>{
        return state.waitlist.allWaitlist;
    })

    const allWaitlistStatuses = useSelector((state)=>{
        return state.waitlist.allWaitlistStatuses;
    })

    const waitlistClients = useSelector((state)=>{
        return state.waitlist.waitlistClients;
    })
   
    const filter = useSelector((state)=>{
        return state.waitlist.filter;
    })

    const isFilterApplied = useSelector((state)=>{
        return state.waitlist.isFilterApplied;
    })

    const selectedWaitlist = useSelector((state)=>{
        return state.waitlist.selectedWaitlist;
    })

    const searchValue = useSelector((state)=>{
        return state.waitlist.searchValue;
    })

    const dispatchWaitlist = useDispatch();

    const GetAllWaitlists = useCallback(async (data)=>{
        try{
            const action = await WaitlistActions.GetAllWaitlists();
            dispatchWaitlist(action);
        }
        catch(err){
            dispatchWaitlist(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
    }, [dispatchWaitlist])

    const GetAllWaitlistStatuses = useCallback(async()=>{
        try{
            const action = await WaitlistActions.GetAllWaitlistStatuses();
            dispatchWaitlist(action)
        }
        catch(err){
            dispatchWaitlist(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
    }, [dispatchWaitlist])

    const GetClientsByWaitlistId = useCallback(async (key, value)=>{
        try{   
            dispatchWaitlist(ShowSpinner());        
            const action = await WaitlistActions.GetClientsByWaitlistId(key, value);
            dispatchWaitlist(action);  
            dispatchWaitlist(HideSpinner());               
        }
        catch(err) { 
            dispatchWaitlist(ErrorToast('Error', _.get(err, 'response.data.message') || err));
            dispatchWaitlist(HideSpinner());      
          }    

    }, [dispatchWaitlist])

    const SetFilter = useCallback((data)=>{
        var action =  WaitlistActions.SetFilter(data);       
        dispatchWaitlist(action);   

    }, [dispatchWaitlist])

    const ResetFilter = useCallback((data)=>{
        var action =  WaitlistActions.ResetFilter(data);       
        dispatchWaitlist(action);   

    }, [dispatchWaitlist])

    const SetSelectedWaitlist = useCallback((selectedWaitlist)=>{
        var action = WaitlistActions.SetSelectedWaitlist(selectedWaitlist);
        dispatchWaitlist(action)
    }, [dispatchWaitlist])

    const AddClientWaitlist = useCallback(async(data)=>{
        try{
            dispatchWaitlist(ShowSpinner());
            var action = await WaitlistActions.AddClientWaitlist(data);
            dispatchWaitlist(action)
            await GetClientsByWaitlistId(selectedWaitlist.id, searchValue)
            dispatchWaitlist(HideSpinner());
            dispatchWaitlist(SuccessToast('Success', 'Successfully added client to waitlist!'));
        }
        catch(err){     
            dispatchWaitlist(HideSpinner());      
            dispatchWaitlist(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }

    }, [dispatchWaitlist, GetClientsByWaitlistId, selectedWaitlist, searchValue])

    const EditClientWaitlist = useCallback(async(data)=>{
        try{
            var action = await WaitlistActions.EditClientWaitlist(data);
            dispatchWaitlist(action)
            await GetClientsByWaitlistId(selectedWaitlist.id, searchValue)
            dispatchWaitlist(SuccessToast('Success', 'Saved Successfully!'));
        }
        catch(err){
            dispatchWaitlist(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }

    }, [dispatchWaitlist, GetClientsByWaitlistId, selectedWaitlist, searchValue])

    let searchTimer;
    const SetSearchValue = (searchValue)=>{ 
        try{ 
            clearTimeout(searchTimer)
            searchTimer = setTimeout(()=>{
            var action =  WaitlistActions.SetSearchValue(searchValue);
                dispatchWaitlist(action)
            }, "1000") 
        }  
        catch(err){
            dispatchWaitlist(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
       
    }
    const RemoveClientWaitlist = useCallback(async(waitlistAssignmentId)=>{
        try{
            var action = await WaitlistActions.RemoveClientWaitlist(waitlistAssignmentId);
            dispatchWaitlist(action)
            await GetClientsByWaitlistId(selectedWaitlist.id, searchValue)
        }
        catch(err){
            dispatchWaitlist(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     

    }, [dispatchWaitlist,GetClientsByWaitlistId, selectedWaitlist, searchValue])



    useEffect(()=>{            
        const GetWaitListClientsAsync = async ()=>{
            if(!_.isNull(selectedWaitlist) && refresh){
                await GetClientsByWaitlistId(_.get(selectedWaitlist,"id"), searchValue)
            }           
        }
        GetWaitListClientsAsync();
    }, [ filter, isFilterApplied, selectedWaitlist, searchValue, refresh, GetClientsByWaitlistId])

    useEffect(()=>{   
        if(refresh){    
            GetAllWaitlists();
            GetAllWaitlistStatuses();
        }
        
    }, [GetAllWaitlists, GetAllWaitlistStatuses, refresh])

    return {data:{allWaitlist, allWaitlistStatuses, waitlistClients, filter, isFilterApplied, selectedWaitlist}, actions:{ SetFilter, ResetFilter, SetSelectedWaitlist, AddClientWaitlist, EditClientWaitlist, SetSearchValue, RemoveClientWaitlist}}
}

export default useWaitlist;